export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            有任何问题或建议，欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="p-6 md:p-7 rounded-2xl border border-background-200 bg-background-50 text-center hover:border-primary-300 transition-colors cursor-pointer">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-primary-500 text-xl md:text-2xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
              内容投稿
            </h3>
            <p className="text-xs md:text-sm text-foreground-500">
              submit@wumacinema.com
            </p>
          </div>

          <div className="p-6 md:p-7 rounded-2xl border border-background-200 bg-background-50 text-center hover:border-primary-300 transition-colors cursor-pointer">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-bug-line text-accent-600 text-xl md:text-2xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
              问题反馈
            </h3>
            <p className="text-xs md:text-sm text-foreground-500">
              feedback@wumacinema.com
            </p>
          </div>

          <div className="p-6 md:p-7 rounded-2xl border border-background-200 bg-background-50 text-center hover:border-primary-300 transition-colors cursor-pointer">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-secondary-600 text-xl md:text-2xl"></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
              合作洽谈
            </h3>
            <p className="text-xs md:text-sm text-foreground-500">
              biz@wumacinema.com
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 p-6 md:p-8 rounded-2xl border border-background-200 bg-background-50 text-center">
          <p className="text-sm text-foreground-600 mb-4">
            也可以直接通过站内留言与我们沟通，我们将尽快回复
          </p>
          <div className="max-w-md mx-auto">
            <div className="flex items-center gap-2">
              <div className="flex-1 h-11 md:h-12 rounded-full border border-background-300 bg-background-100 px-5 flex items-center text-sm text-foreground-500 cursor-text">
                <i className="ri-chat-3-line mr-2 text-foreground-400"></i>
                输入你的留言内容……
              </div>
              <button className="h-11 md:h-12 px-6 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer">
                发送
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}